// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3k5yc","label":"Radio_label__vilFr","checkMark":"Radio_checkMark__2Z7RB","disabled":"Radio_disabled__1OtID"};